// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"988c04e6","110":"a351d29a","258":"e4eb0b65","547":"841ecb79","638":"a6280be0","729":"850eb393","878":"da101560","916":"62e27470","932":"2ae55bd0"}[chunkId] + ".chunk.css";
};